import React, { useEffect, useState } from 'react'
import { LoadAllAbout, LoadAllContact, LoadAllContactFooter } from '../actions/ActivitesPages/ManagerPageAction';

const Footer = () => {


    const [id, setid] = useState();

    const [coverPicture, setcoverPicture] = useState();
    const [logo, setlogo] = useState();
    const [name, setname] = useState();
    const [email, setemail] = useState();
    const [telephone1, settelephone1] = useState();
    const [telephone2, settelephone2] = useState();
    const [telephone3, settelephone3] = useState();

    const [facebook, setfacebook] = useState();
    const [youtube, setyoutube] = useState();
    const [instagram, setinstagram] = useState();



    const [Loading, setLoading] = useState();

    useEffect(() => {
        LoadAllContact(setid, setlogo, setname, setcoverPicture,
            setemail, settelephone1, settelephone2, settelephone3,
            setfacebook, setyoutube, setinstagram)
    }, []);
    return (
        <div>
            <div className="container-fluid bg-dark mt-5 py-5">
                <div className="container pt-5">
                    <div className="row g-5">
                        <div className="col-lg-3 col-md-6">
                            <h5 className="text-uppercase border-start border-5  ps-3 mb-4"><img src={logo} style={{ height: "40px", width: "40px" }} /></h5>
                            <p className="mb-4 translatable">Nous contacter</p>
                            <p className="mb-2 text-white flex space-x-2"><i className="bi bi-geo-alt text-primary me-2"></i>
                                <img
                                    src="https://img.freepik.com/vecteurs-premium/drapeau-cote-ivoire-vecteur_671352-101.jpg?w=1060"
                                    className="h-5 w-5 rounded-lg"
                                />
                                <span className="translatable">Côte d{"'"}ivoire , Deux Plateaux , Careffour Marché</span>
                            </p>
                            <p className="mb-2 text-white flex space-x-2"><i className="bi bi-geo-alt text-primary me-2"></i>
                                <img
                                    src="https://img.freepik.com/vecteurs-premium/drapeau-du-ghana-vecteur_671352-85.jpg?w=1060"
                                    className="h-5 w-5 rounded-lg"
                                />
                                <span className="translatable">Ghana</span>
                            </p>
                            <p className="mb-2 text-white flex space-x-2"><i className="bi bi-geo-alt text-primary me-2"></i>
                                <img
                                    src="https://img.freepik.com/vecteurs-libre/illustration-du-drapeau-france_53876-27099.jpg?w=1060&t=st=1693326599~exp=1693327199~hmac=2d48b3ebab5a4e1caee14c0789c6f8719974fca67902908b833d89dcf94591a3"
                                    className="h-5 w-5 rounded-lg"
                                />
                                <span className="translatable">France</span>
                            </p>
                            <p className="mb-2 text-white"><i className="bi bi-envelope-open text-white me-2"></i><a href={`mailto:${email}`}>{email}</a></p>
                            <p className="mb-0 text-white"><i className="bi bi-telephone text-white me-2"></i><a href={`tel:${telephone1}`}>{telephone1}</a></p>
                            <p className="mb-0 text-white"><i className="bi bi-telephone text-white me-2"></i><a href={`tel:${telephone2}`}>{telephone2}</a></p>
                            <p className="mb-0 text-white"><i className="bi bi-telephone text-white me-2"></i><a href={`tel:${telephone3}`}>{telephone3}</a></p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <h5 className="text-white text-uppercase border-start border-5 border-primary ps-3 mb-4 translatable">Activités</h5>
                            <div className="d-flex flex-column justify-content-start">
                                <a className="text-white mb-2" href="#"><i className="bi bi-arrow-right text-primary me-2"></i><span>enseignements </span></a>
                                <a className="text-white" href="#"><i className="bi bi-arrow-right text-primary me-2"></i><span>temoignages </span></a>
                                <a className="text-white" href="#"><i className="bi bi-arrow-right text-primary me-2"></i><span>dons </span></a>
                                <a className="text-white" href="#"><i className="bi bi-arrow-right text-primary me-2"></i><span>evenement </span></a>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <h5 className="text-white text-uppercase border-start border-5 border-primary ps-3 mb-4 translatable">pages</h5>
                            <div className="d-flex flex-column justify-content-start">
                                <a className="text-white mb-2" href="#"><i className="bi bi-arrow-right text-primary me-2"></i><span>Accueil </span></a>
                                <a className="text-white mb-2" href="#"><i className="bi bi-arrow-right text-primary me-2"></i>A  propos de nous ?</a>
                                <a className="text-white mb-2" href="#"><i className="bi bi-arrow-right text-primary me-2"></i><span>témoignages </span> ?</a>
                                <a className="text-white mb-2" href="#"><i className="bi bi-arrow-right text-primary me-2"></i><span>contact </span></a>
                                <a className="text-white mb-2" href="#"><i className="bi bi-arrow-right text-primary me-2"></i><span>contact </span></a>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <h5 className="text-uppercase border-start border-5 border-primary ps-3 mb-4 translatable">Sociaux</h5>
                            <form action="">
                                <div className="input-group">
                                    <input type="email" className="form-control p-3 translatable" placeholder="votre email" />
                                    <button className="btn btn-primary translatable">envoyer</button>
                                </div>
                            </form>
                            <h6 className="text-uppercase mt-4 mb-3 translatable">Nous suivre</h6>
                            <div className="d-flex">
                                <a className="btn btn-outline-primary btn-square me-2" href={`${youtube}`} target='_blank'><i className="bi bi-youtube"></i></a>
                                <a className="btn btn-outline-primary btn-square me-2" href={`${facebook}`} target='_blank'><i className="bi bi-facebook"></i></a>
                                <a className="btn btn-outline-primary btn-square" href={`${instagram}`} target='_blank'><i className="bi bi-instagram"></i></a>
                            </div>
                        </div>
                        <div className="col-12 text-center text-body">
                            <a className="text-body translatable" href="#">Terms & Conditions</a>
                            <span className="mx-1">|</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid bg-dark text-white-50 py-4">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-md-6 text-center text-md-start">
                            <p className="mb-md-0">&copy;<span className="translatable"> Autres Sites </span>  :  <a className="text-white" href="https://plenitude-ci.org">www.plenitude-ci.com </a> , <a className="text-white" href="https://plenitude-ci.org">plenitude-ci.org </a>. Tous droit Réserves.</p>
                        </div>
                        <div className="col-md-6 text-center text-md-end">
                            <p className="mb-0"><span className="translatable">Designed by </span><a className="text-white" href="https://mon-portfolio-mxunivers.web.app">Developper Full Stack "Aymar Bly +225 0595387052"</a></p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Footer;